import { render, staticRenderFns } from "./FootballPlayerShotmap.vue?vue&type=template&id=0cb26270&scoped=true&"
import script from "./FootballPlayerShotmap.vue?vue&type=script&lang=js&"
export * from "./FootballPlayerShotmap.vue?vue&type=script&lang=js&"
import style0 from "./FootballPlayerShotmap.vue?vue&type=style&index=0&id=0cb26270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb26270",
  null
  
)

export default component.exports